import React from 'react';

export const RippleTrackIcon = (props: { size: number; color: string }) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.25 6H2"
      stroke={props.color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.375 2.625L2 6L5.375 9.375"
      stroke={props.color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const KeepGapIcon = (props: { size: number; color: string }) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.125 7.3125C1.125 7.62316 0.87316 7.875 0.5625 7.875C0.25184 7.875 0 7.62316 0 7.3125L0 0.5625C0 0.25184 0.25184 0 0.5625 0C0.87316 0 1.125 0.25184 1.125 0.5625L1.125 7.3125Z"
      fill={props.color}
    />
    <path
      d="M7.125 7.3125C7.125 7.62316 6.87316 7.875 6.5625 7.875C6.25184 7.875 6 7.62316 6 7.3125V0.5625C6 0.25184 6.25184 0 6.5625 0C6.87316 0 7.125 0.25184 7.125 0.5625L7.125 7.3125Z"
      fill={props.color}
    />
  </svg>
);

export const ArrowUpIcon = (props?: {
  color?: string;
  stroke?: string;
  rotate?: string;
}) => (
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    style={{ transform: props?.rotate ? `rotate(${props.rotate})` : undefined }}
  >
    <path
      d="M9 5.5L5 1.5L1 5.5"
      stroke={props?.stroke || props?.color || 'currentColor'}
      strokeWidth="2"
    />
  </svg>
);
